import { BrowserRouter, Routes, Route } from "react-router-dom";
import InsightNestPage from "./Routes/View";
import Home from "./Routes/Index";
import { IdeaValidator } from "./Routes/ValidateForm";
import PayPalLogin from "./Routes/payment";
import Pricing from "./Routes/Plans";
// import ForgotPassword from "./Routes/forgotPassword";

const App = () => {
  return (
    <BrowserRouter basename="/home">  {/* Set basename here */}
      <Routes>
        <Route index element={<Home />} />
        <Route path="view/:Id" element={<InsightNestPage />} />
        <Route path="validator" element={<IdeaValidator />} />
        <Route path="plans" element={<Pricing />} />
        {/* <Route path="forgotpassword" element={<ForgotPassword />} /> */}
        <Route path="payment/:planId" element={<PayPalLogin />} />
        {/* <Route path="*" element={<NoPage />} /> */}
      </Routes>
    </BrowserRouter>
  );
};

export default App;
